import React, { useState } from "react";

import { Btn, Icon } from "../../catalogProductStudio/edit/StudioUi";
import { fill, formatRelative, plural } from "../printCenterModel";

/**
 * Prints still waiting for someone to say whether the labels came out. Shown
 * on every visit (after a refresh, the next day, on another device) so new
 * stock never stays reserved by a forgotten job. The person's own jobs come
 * first; colleagues' jobs are listed so anyone can resolve them.
 */
function PendingPrintsBanner({ tt, jobs, userId, hiddenJobId, onOpenJob, onConfirmJob }) {
  const [collapsed, setCollapsed] = useState(false);
  const visible = (jobs || []).filter((job) => job.jobId !== hiddenJobId);
  if (!visible.length || collapsed) return null;

  const mine = visible.filter((job) => userId != null && Number(job.createdById) === Number(userId));
  const others = visible.filter((job) => !mine.includes(job));
  const title = mine.length
    ? mine.length === 1
      ? tt("recoveryTitleMine")
      : fill(tt("recoveryTitleMineOther"), { count: mine.length })
    : others.length === 1
    ? tt("recoveryTitleOthersOne")
    : fill(tt("recoveryTitleOthers"), { count: others.length });

  return (
    <section className="pc-recovery" aria-label={title}>
      <Icon name="alert" size={18} className="pc-recovery__icon" />
      <div className="pc-recovery__body">
        <strong>{title}</strong>
        <p className="pc-muted pc-small">{tt("awaitingCopy")}</p>
        <ul className="pc-recovery__jobs">
          {[...mine, ...others].map((job) => (
            <li key={job.jobId}>
              <span>
                {fill(tt(mine.includes(job) ? "recoveryJob" : "recoveryJobBy"), {
                  job: job.jobId,
                  labels: plural(tt, "newLabelCount", job.newStockLabels),
                  name: job.createdByName || "—",
                  time: formatRelative(tt, job.createdAt),
                })}
              </span>
              <span className="pc-recovery__actions">
                <Btn size="sm" variant="ghost" onClick={() => onOpenJob(job.jobId)}>
                  {tt("recoveryOpen")}
                </Btn>
                <Btn size="sm" variant="primary" icon="checkCircle" onClick={() => onConfirmJob(job.jobId)}>
                  {tt("recoveryConfirm")}
                </Btn>
              </span>
            </li>
          ))}
        </ul>
        <span className="pc-sr-only">{plural(tt, "awaitingCount", visible.length)}</span>
      </div>
      <button type="button" className="pse-icon-btn" aria-label={tt("close")} onClick={() => setCollapsed(true)}>
        <Icon name="x" size={14} />
      </button>
    </section>
  );
}

export default PendingPrintsBanner;
